// TODO: build-out enum of supported localised statuses
const AVAILABILITY_LOCALIZED_STATUS = {
  AVAILABLE: 'AVAILABLE',
  AVAILABLE_BY_REQUEST: 'AVAILABLE_BY_REQUEST',
  AVAILABLE_IN_BRANCH: 'AVAILABLE_IN_BRANCH',
  AVAILABLE_IN_SINGLE_BRANCH: 'AVAILABLE_IN_SINGLE_BRANCH',
  AVAILABLE_NOT_HOLDABLE: 'AVAILABLE_NOT_HOLDABLE',
  AVAILABLE_NOT_HOLDABLE_AT_THIS_TIME: 'AVAILABLE_NOT_HOLDABLE_AT_THIS_TIME',
  DELETED: 'DELETED',
  DIGITAL_ALWAYS_AVAILABLE: 'DIGITAL_ALWAYS_AVAILABLE',
  ON_ORDER: 'ON_ORDER',
  RESTRICTED_ACCESS: 'RESTRICTED_ACCESS',
  UNAVAILABLE: 'UNAVAILABLE',
  UNKNOWN: 'UNKNOWN'
};

// TODO: build-out enum
const AVAILABILITY_LOCATION_TYPE = {
  LOCAL: 'LOCAL',
  NOT_APPLICABLE: 'NA',
  OTHER: 'OTHER',
  PREFERRED: 'PREFERRED'
};

const AVAILABILITY_ROLLUP_STATUS = {
  AVAILABLE: 'AVAILABLE',
  ON_ORDER: 'ON_ORDER',
  UNAVAILABLE: 'UNAVAILABLE',
  UNKNOWN: 'UNKNOWN'
};

export { AVAILABILITY_LOCALIZED_STATUS, AVAILABILITY_LOCATION_TYPE, AVAILABILITY_ROLLUP_STATUS };
